import React from 'react';

import AdminLayout from 'Pages/Admin/AdminLayout';
import {PollResultsGraph} from 'Components/MainStage';

import Base from 'Pages/MainStage/Base';
import { asset } from "Services/BaseHelpers";
import { Loading } from "Components/Partials/index";
import { translation } from "Services/TranslationHelpers";
import { Link } from "react-router-dom";

export default class LiveResults extends Base {
    /**
     * @var state
     */
    state = {
        currentSession: null,
        currentPoll: null
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.mountBase();
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        this.unmountBase();
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {working, currentSession, currentPoll } = this.state;
        const params = new URLSearchParams(window.location.search);
        const screenMode = params.get('screen') === '1';
        const aspect = params.get('aspect');

        // Make root a full-height flex container and center contents
        const rootClass = `min-h-screen w-full flex items-center justify-center ${screenMode ? 'bg-gradient-to-br bg-cover from-app-blue via-white to-app-light-blue' : 'bg-white bg-cover bg-no-repeat'}`;

        const innerStyle = screenMode && aspect !== 'side' ? { aspectRatio: '16 / 9' } : {};

        return (
            <div className={ rootClass }>
                <div style={ innerStyle } className="w-full flex items-center justify-center">

                    <div className={`${screenMode ? 'p-4 lg:px-8 flex items-center justify-center' : 'p-4 md:px-0 flex items-center justify-center'} mx-auto px-4 relative z-10 w-full max-w-6xl`}>
                        { working && ( <Loading /> ) }

                        { !working && (
                            <React.Fragment>
                                { !currentPoll?.id &&
                                    <div className="flex flex-col items-center justify-center w-full">
                                        <div className="bg-white/90 rounded-2xl shadow-xl px-8 py-12 max-w-4xl mx-auto">
                                            <p className="font-extrabold text-2xl text-indigo-700 text-center tracking-tight">
                                                No live poll running
                                            </p>
                                            <p className="text-gray-500 text-center mt-2">
                                                Please start a poll to see live results.
                                            </p>
                                        </div>
                                    </div>
                                }

                                { currentPoll?.id &&
                                    <div className="w-full flex items-center justify-center">
                                        <div className="bg-app-blue rounded-2xl shadow-2xl px-6 py-8 w-full max-w-6xl">
                                            <PollResultsGraph
                                                session_id={ currentSession?.id }
                                                poll_id={ currentPoll?.id }
                                            />
                                        </div>
                                    </div>
                                }
                            </React.Fragment>
                        ) }

                    </div>
                </div>
            </div>
        );
    }
}
